<template>
  <div>
      <header-page
        :title="title"
        showEntidadSelector
      />
      <div class="row col-12 espacio" data-cy="headerMisIndicadores" v-if="serviciosIndicador.length > 0">
        <div class="container-entidad-img">
          <q-img :src="require('@/assets/img/logo-dinapsis-aplicaciones.svg')"/>
        </div>
        <div class="textBodyServicio">{{ indicadoresTitle }}</div>
      </div>
      <q-expansion-item
              header-style="padding-left: 220px"
              v-if="serviciosIndicador.length > 0"
              default-opened
            >
        <div class="row espacio-content">
            <div
              class="col-xl-4 col-lg-4 col-md-6 col-xs-12"
              v-for="servicio in serviciosIndicador"
              v-bind:key="servicio.id"
              style="margin-bottom: 20px; padding-right:15px;"
            >
              <ContenedorServicio :datos="servicio" dataCy="serviciosIndicador" />
            </div>
        </div>
      </q-expansion-item>
      <div class="row col-12 espacio" data-cy="headerMisServiciosDigitales" v-if="isEntidadSelected">
        <div class="container-entidad-img">
          <q-img :src="require('@/assets/img/logo-dinapsis-aplicaciones.svg')"/>
        </div>
          <div class="textBodyServicio">{{ serviciosDigitalesTitle }}</div>
      </div>
      <q-expansion-item
              v-if="isEntidadSelected"
              header-style="padding-left: 268px"
              default-opened
            >
      <div class="row espacio-content">
          <div v-if="serviciosDigitales.length == 0" class="textBodyServicioUpcoming" data-cy="textUpcomingAvailable">
            {{ this.noticeOfUpcomingServices }}
          </div>
          <div
           class="col-xl-4 col-lg-4 col-md-6 col-xs-12"
            v-for="servicio in serviciosDigitales"
            v-bind:key="servicio.id"
            style="margin-bottom: 20px; padding-right:15px;"
          >
            <ContenedorServicio :datos="servicio" dataCy="serviciosDigitales" />
          </div>
      </div>
    </q-expansion-item>
  </div>
</template>

<script>
import HeaderPage from '@/shared/top-bar/components/HeaderPage.vue';
import ContenedorServicio from '../components/ContenedorServicio.vue';
import { QImg } from 'quasar';
export default {
  components: {
    HeaderPage,
    ContenedorServicio,
    QImg
  },
  async created () {
    await this.$eventHub.$on('refreshIndicadoresYServiciosDigitales', (entidad) => {
      if (entidad) {
        this.isEntidadSelected = true;
        this.getServicios(entidad);
        this.serviciosDigitalesTitle = entidad.titleService;
        this.indicadoresTitle = entidad.titleIndicator;
      }
    });
  },
  data () {
    return {
      title: '', // texto al final del headerpage
      serviciosDigitalesTitle: '',
      indicadoresTitle: '',
      noticeOfUpcomingServices: 'Disponible Próximamente',
      servicios: [],
      serviciosDigitales: [],
      serviciosIndicador: [],
      isEntidadSelected: false
    };
  },
  methods: {
    async getServicios (entidad) {
      let idUser = this.$store.getters['PF/userId'];
      if (idUser && entidad) {
        let request = {
          controller: `/Entidad/${entidad.id}/User/${idUser}/ServicioUser`
        };
        await this.$store
          .dispatch('PF/getSuit', request)
          .then((response) => {
            this.servicios = response.data;
            this.serviciosIndicador = response.data.filter(servicio => servicio.tags.length > 0 && servicio.tags[0] === 'TYPE_INDICADORES');
            this.serviciosDigitales = response.data.filter(servicio => !(servicio.tags.length > 0 && servicio.tags[0] === 'TYPE_INDICADORES'));
          })
          .catch((err) => {
            this.showError(err.message);
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container-entidad-img
{
  background: white;
  border-radius: 65%;
  width:58px;
  padding: 12px 16px 10px 16px;
  display: flex;
}
.espacio {
  margin-top: 50px;
  margin-left:-50px;
  .espacios {
    padding-bottom: 24px;
    justify-content: space-around;
    padding-right: 24px !important;
  }
}
.espacio-content {
  margin-left:-50px;
}
.title {
  font-family: DINPro;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.32px;
  height: min-content;
  margin: auto;
  margin-left: 15px;
  color: $dinapsis-marine-blue;
  padding: 20px;
}
.containerLogo
  {
    padding: 11px 0 0 16px;
    border-radius: 12px 0 0 12px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    width: 42px;
  }
  .textBodyServicio {
  font-family: DINPro;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.32px;
  height: min-content;
  margin: auto;
  margin-left: 15px;
  color: $dinapsis-marine-blue;
}
.textBodyServicioUpcoming{
  font-family: DINPro;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.32px;
  height: min-content;
  margin: auto;
  margin-left: 30px;
  color: black;
}

:deep(){
  .q-item__section--main {
    position:fixed;
  }
  .q-item__section--main ~ .q-item__section--side{
    margin-top:-105px;
  }
  .q-hoverable, .q-focusable{
    background-color: transparent;
  }
  .q-focus-helper, body.desktop .q-hoverable:hover > .q-focus-helper{
    color: transparent;
    background-color: transparent;
    opacity: 0;
  }
  body.desktop .q-focusable:focus > .q-focus-helper, body.desktop .q-manual-focusable--focused > .q-focus-helper{
    color: transparent;
    background-color: transparent;
    opacity: 0;
  }
}
</style>
